import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import type { ExecutiveFilterState } from 'api/executive/executive.types'
import PerformanceApi from 'api/executive/performance.api'
import type {
  GetKeyProceduresDetailParams,
  GetKeyProceduresDetailResponse,
} from 'api/executive/executive.types'

export function useKeyProceduresDetail(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetKeyProceduresDetailParams, GetKeyProceduresDetailResponse>(
    'performance.key-procedures-detail',
    PerformanceApi.getKeyProceduresDetail,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
      }
    },
    { scopedFilters }
  )
}
